import {redactEmails} from 'src/common/logger/formatPathForLog'

export class PrismicLookupError extends Error {
  readonly name = 'PrismicLookupError'

  constructor(
    readonly type: string,
    readonly uid: string,
    readonly locale: string,
    cause: unknown,
  ) {
    super(`Prismic lookup failed for ${type} "${redactEmails(uid)}"`, {cause})
  }
}
